import {
  EVENT_BUS_ACCOUNT_SWITCH_REQUESTED,
  EVENT_BUS_JUMP_REQUESTED,
  JumpEventBus,
} from '../_events/jump.bus';

import {
  type Persona,
  PERSONA_TYPES,
} from '../console/_statics/persona.statics';
import { type Languages, languages } from '../i18n/i18n.language-config';

export const yesNoOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export function jumpRequested(
  accountType: Persona,
  accountId: string,
  accountName?: string
) {
  JumpEventBus.publish(EVENT_BUS_JUMP_REQUESTED, {
    accountType,
    accountId,
    accountName,
  });
}

export function onJumpRequested(
  ...args: [Persona, string, string | undefined]
) {
  return () => jumpRequested(...args);
}

export function accountSwitchRequested(
  accountType: Persona,
  accountId: string,
  accountName?: string
) {
  JumpEventBus.publish(EVENT_BUS_ACCOUNT_SWITCH_REQUESTED, {
    accountType,
    accountId,
    accountName,
  });
}

export function onAccountSwitchRequested(
  ...args: [Persona, string, string | undefined]
) {
  return () => accountSwitchRequested(...args);
}

/**
 * @name exchangePersonaForPath
 * @description Instead of defining many apis for jump token exchange, we defined one and swap a path parameter
 */
export function exchangePersonaForPath(persona: Persona) {
  switch (persona) {
    case PERSONA_TYPES.AGENCY:
      return 'admin/agencies';
    case PERSONA_TYPES.CUSTOMER:
      return 'accounts';
    case PERSONA_TYPES.DIGITAL:
      return 'da';
    case PERSONA_TYPES.MSSP:
      return 'mssp';
    case PERSONA_TYPES.CARRIER:
      return 'carrier';
    case PERSONA_TYPES.VENDOR:
      return 'vendor';
    case PERSONA_TYPES.CLUSTER:
      return 'cluster';
    case PERSONA_TYPES.RE_INSURER:
      return 'reinsurer';
    case PERSONA_TYPES.PREMIUM_PROCESSOR:
      return 'premiumprocessor';
    case PERSONA_TYPES.POOL:
      return 'pool';
    case PERSONA_TYPES.FRANCHISE:
      return 'franchise';
    default:
      return null;
  }
}

export const getPlatformRegion = (featureFlags?: {
  ukEnvironment?: boolean;
  auEnvironment?: boolean;
}): Languages => {
  const url = new URL(window.location.href);

  if (url.hostname.endsWith('.co.uk') || featureFlags?.ukEnvironment) {
    return languages['en-GB'];
  }

  if (
    url.hostname.endsWith('.au') ||
    url.hostname.endsWith('morecowbellau.com') ||
    featureFlags?.auEnvironment
  ) {
    return languages['en-AU'];
  }

  return languages['en-US'];
};

export const getIsUsPlatform = (region: Languages) =>
  region === languages['en-US'];

export const getIsUkPlatform = (region: Languages) =>
  region === languages['en-GB'];

export const getIsAuPlatform = (region: Languages) =>
  region === languages['en-AU'];

export const getHasStateInAddress = (region: Languages) =>
  getIsUsPlatform(region) || getIsAuPlatform(region);

export function isPromise<T = unknown>(
  val: Promise<T> | unknown
): val is Promise<T> {
  // @ts-expect-error TS(2571): Object is of type 'unknown'.
  return typeof val?.then == 'function';
}
